// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-navigationHelpButton-wrapper {
  position: relative;
  display: inline-block;
}

.cesium-navigation-help {
  visibility: hidden;
  position: absolute;
  top: 38px;
  right: 2px;
  width: 250px;
  border-radius: 10px;
  transform: scale(0.01);
  transform-origin: 234px -10px;
  transition:
    visibility 0s 0.25s,
    transform 0.25s ease-in;
}

.cesium-navigation-help-visible {
  visibility: visible;
  transform: scale(1);
  transition: transform 0.25s ease-out;
}

.cesium-navigation-help-instructions {
  border: 1px solid #444;
  background-color: rgba(38, 38, 38, 0.75);
  padding-bottom: 5px;
  border-radius: 0 0 10px 10px;
}

.cesium-click-navigation-help {
  display: none;
}

.cesium-touch-navigation-help {
  display: none;
  padding-top: 5px;
}

.cesium-click-navigation-help-visible {
  display: block;
}

.cesium-touch-navigation-help-visible {
  display: block;
}

.cesium-navigation-help-pan {
  color: #66ccff;
  font-weight: bold;
}

.cesium-navigation-help-zoom {
  color: #65fd00;
  font-weight: bold;
}

.cesium-navigation-help-rotate {
  color: #ffd800;
  font-weight: bold;
}

.cesium-navigation-help-tilt {
  color: #d800d8;
  font-weight: bold;
}

.cesium-navigation-help-details {
  color: #ffffff;
}

.cesium-navigation-button {
  color: #fff;
  background-color: transparent;
  border-bottom: none;
  border-top: 1px solid #444;
  border-right: 1px solid #444;
  margin: 0;
  width: 50%;
  cursor: pointer;
}

.cesium-navigation-button-icon {
  vertical-align: middle;
  padding: 5px 1px;
}

.cesium-navigation-button:focus {
  outline: none;
}

.cesium-navigation-button-left {
  border-radius: 10px 0 0 0;
  border-left: 1px solid #444;
}

.cesium-navigation-button-right {
  border-radius: 0 10px 0 0;
  border-left: none;
}

.cesium-navigation-button-selected {
  background-color: rgba(38, 38, 38, 0.75);
}

.cesium-navigation-button-unselected {
  background-color: rgba(0, 0, 0, 0.75);
}

.cesium-navigation-button-unselected:hover {
  background-color: rgba(76, 76, 76, 0.75);
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/NavigationHelpButton/NavigationHelpButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".cesium-navigationHelpButton-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.cesium-navigation-help {\n  visibility: hidden;\n  position: absolute;\n  top: 38px;\n  right: 2px;\n  width: 250px;\n  border-radius: 10px;\n  transform: scale(0.01);\n  transform-origin: 234px -10px;\n  transition:\n    visibility 0s 0.25s,\n    transform 0.25s ease-in;\n}\n\n.cesium-navigation-help-visible {\n  visibility: visible;\n  transform: scale(1);\n  transition: transform 0.25s ease-out;\n}\n\n.cesium-navigation-help-instructions {\n  border: 1px solid #444;\n  background-color: rgba(38, 38, 38, 0.75);\n  padding-bottom: 5px;\n  border-radius: 0 0 10px 10px;\n}\n\n.cesium-click-navigation-help {\n  display: none;\n}\n\n.cesium-touch-navigation-help {\n  display: none;\n  padding-top: 5px;\n}\n\n.cesium-click-navigation-help-visible {\n  display: block;\n}\n\n.cesium-touch-navigation-help-visible {\n  display: block;\n}\n\n.cesium-navigation-help-pan {\n  color: #66ccff;\n  font-weight: bold;\n}\n\n.cesium-navigation-help-zoom {\n  color: #65fd00;\n  font-weight: bold;\n}\n\n.cesium-navigation-help-rotate {\n  color: #ffd800;\n  font-weight: bold;\n}\n\n.cesium-navigation-help-tilt {\n  color: #d800d8;\n  font-weight: bold;\n}\n\n.cesium-navigation-help-details {\n  color: #ffffff;\n}\n\n.cesium-navigation-button {\n  color: #fff;\n  background-color: transparent;\n  border-bottom: none;\n  border-top: 1px solid #444;\n  border-right: 1px solid #444;\n  margin: 0;\n  width: 50%;\n  cursor: pointer;\n}\n\n.cesium-navigation-button-icon {\n  vertical-align: middle;\n  padding: 5px 1px;\n}\n\n.cesium-navigation-button:focus {\n  outline: none;\n}\n\n.cesium-navigation-button-left {\n  border-radius: 10px 0 0 0;\n  border-left: 1px solid #444;\n}\n\n.cesium-navigation-button-right {\n  border-radius: 0 10px 0 0;\n  border-left: none;\n}\n\n.cesium-navigation-button-selected {\n  background-color: rgba(38, 38, 38, 0.75);\n}\n\n.cesium-navigation-button-unselected {\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.cesium-navigation-button-unselected:hover {\n  background-color: rgba(76, 76, 76, 0.75);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
